import { useState } from 'react';
import { getModelsWithHealth } from '../services/modelService';
import { formatModelName } from '../utils/messageUtils';

export const useModels = () => {
  const [models, setModels] = useState([]);
  const [model, setModel] = useState('');
  const [isModelsLoading, setIsModelsLoading] = useState(true);

  const fetchModelsData = async () => {
    try {
      setIsModelsLoading(true);
      const modelsData = await getModelsWithHealth();

      const processedModels = modelsData.map(model => ({
        value: model.key,
        label: formatModelName(model.key),
        isThinkingModel: model.key.toLowerCase().includes('deepseek'),
        isHealthy: model.isHealthy
      }));

      setModels(processedModels);

      const healthyModels = processedModels.filter(m => m.isHealthy);
      if (healthyModels.length > 0 && !model) {
        setModel(healthyModels[0].value);
      } else if (!processedModels.some(m => m.value === model && m.isHealthy)) {
        if (healthyModels.length > 0) {
          setModel(healthyModels[0].value);
        }
      }
    } catch (error) {
      console.error('Failed to fetch models:', error);
      setModels([]);
    } finally {
      setIsModelsLoading(false);
    }
  };

  const isCurrentModelThinkingModel = () => {
    const currentModel = models.find(m => m.value === model);
    return currentModel?.isThinkingModel || model.toLowerCase().includes('deepseek');
  };

  return {
    models,
    model,
    setModel,
    isModelsLoading,
    fetchModelsData,
    isCurrentModelThinkingModel
  };
};

